<template>
  <div
    ref="rootEl"
    class="guidance-panel"
    :style="positionStyle"
    @click.stop
  >
    <div class="guidance-panel__text">
      {{ t(config.textKey) }}
    </div>
    <div class="guidance-panel__actions">
      <DxButton
        v-if="canGoBack"
        :text="t('guidance.backButton')"
        :title="t('guidance.backButtonTitle')"
        type="normal"
        styling-mode="outlined"
        class="guidance-panel__back-btn"
        @click="emit('goBack')"
      />
      <DxButton
        :text="`${t('guidance.panelContinueButton')} →`"
        type="default"
        styling-mode="outlined"
        class="guidance-panel__continue-btn"
        @click="emit('advance')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import DxButton from "devextreme-vue/button";
import type { GuidanceStepConfig } from "../models/guidance/GuidanceTypes";

interface Props {
  config: GuidanceStepConfig;
  positionStyle: Record<string, string>;
  canGoBack: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  advance: [];
  goBack: [];
}>();

const { t } = useI18n();

const rootEl = ref<HTMLElement | null>(null);

defineExpose({ rootEl });
</script>
